import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

// The studio access tier is null in the shared fast-page store and only hydrates
// from /load-services.js (see useHydrateGenerationQuota), which runs only once the
// user is known to be logged in. This reports that unresolved window so a
// client-only component can optimistically treat a logged-in user as entitled and
// avoid flashing - and announcing to assistive tech - a paid-only upsell before the
// real tier arrives.
//
// Do NOT use this to gate SSR-rendered markup. `isLoggedIn` comes from pageConfig,
// which can resolve before hydration, so a server render (pageConfig undefined ->
// not pending) and the first client render (pageConfig resolved -> pending) would
// disagree on tree shape and trip a React 18 hydration mismatch. SSR-rendered gating
// must derive from store state that is null on both sides of hydration.
//
// Deliberately keyed on the tier alone, even though FooterActions composes it with the
// premiumFeatures-based DCC gate. Those two fields can resolve independently
// (setStudioAccessTier writes the tier without touching premiumFeatures), but widening
// this to cover both would make the optimistic unlock fire in more cases, not fewer,
// and would couple generation gating to an entitlement it has nothing to do with.
// The mismatch fails closed: access is denied, never granted.
export default function useStudioAccessTierPending() {
  const pageConfig = usePageConfig()
  const isLoggedIn = pageConfig?.isCurrentUser ?? false
  const studioAccessTier = useThreeDStudioStore((state) => state.subscription.studioAccessTier)

  return isLoggedIn && studioAccessTier === null
}
